import {AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChange} from '@angular/core';
import {PointOfSaleDto} from "../../point-of-sale-dto";

@Component({
    selector: 'miami-instructions',
    templateUrl: './miami-instructions.component.html',
    providers: []
})
export class MiamiInstructionsComponent implements OnInit, AfterViewInit, OnChanges{

    @Input() errors;
    @Input() dto:PointOfSaleDto;
    @Input() countryId;
    @Input() isValidLocation;

    platforms:any[] = [
            {value: "1", checked:false},
            {value: "2", checked:false},
            {value: "3", checked:false},
            {value: "4", checked:false}
        ];

    missedPositionsRCC:boolean = false;
    PHONE_PREFIX:string = "+1 ";
    FREE_LINE:string[] = ["800","888","877","866","855","844","833"];
    isEditing:boolean=true;
    isValid:boolean=true;

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
        this.dto.pickupIndications.meetingType="CALL";

        if (this.dto.pickupIndications.miamiAirportPositions) {
            this.checkPlatformsSelected();
        }
        else {
            this.dto.pickupIndications.miamiAirportPositions = new Array();
        }
    }

     checkPlatformsSelected() {
         for (let item in this.platforms) {
             let position = this.platforms[item];
             position.checked = this.dto.pickupIndications.miamiAirportPositions.includes(position.value);
         }
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {
        let currentErrors = changes['errors'] ? changes['errors'].currentValue : undefined;
        this.isValid = changes['isValidLocation'] ? changes['isValidLocation'].currentValue : undefined;
        this.missedPositionsRCC = currentErrors && currentErrors.miamiAirportPositionsRequired;

        if(this.isValid === false) {
            this.dto.pickupIndications.miamiAirportPositions = Array();
            this.platforms = [
                {value: "1", checked:false},
                {value: "2", checked:false},
                {value: "3", checked:false},
                {value: "4", checked:false}
            ];
        }
    }

     addCheckbox(item, isChecked) {
        this.missedPositionsRCC = false;

        if(isChecked) {
            this.dto.pickupIndications.miamiAirportPositions.push(item.value.toString());
        }
        else {
            if(this.dto.pickupIndications.miamiAirportPositions.length > 0){
                this.dto.pickupIndications.miamiAirportPositions = this.dto.pickupIndications.miamiAirportPositions.filter(obj => obj !== item.value.toString());
            }
        }
     }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/miami-instructions/miami-instructions.component.ts